import React from 'react'

const ClickEmoji = () => {
    return (
        <span style={{ display: 'inline-block' }}>
            <img height="15" src="/cursor.png" alt='cursor'></img>
        </span>
    )
}

export default ClickEmoji